/**
 * ops 面のパーミッション語彙。
 *
 * 語彙の唯一の正は `packages/shared/src/rbac.ts`（ARCHITECTURE §7.2）。
 * ここは**再 export と画面用のヘルパだけ**にする。文字列を 2 か所に持つと
 * 必ずずれて「ボタンは出るが 403」「権限はあるのにボタンが出ない」になるため、
 * 定数を手で並べ直すことを禁止する。
 *
 * ロールからの導出はサーバーに任せる。`GET /api/v1/auth/ops/me` が返す
 * `perms[]` が唯一の判定材料で、SPA でロール名を直接比較しない
 * （`role === 'superadmin'` のような分岐を書かない）。
 */
import { OPS_PERMISSION, type OpsPermission } from '@mail-sv/shared';

export { OPS_PERMISSION };
export type { OpsPermission };

/** 権限不足時に画面へ出す文言。403 の生メッセージより具体的にする。 */
export const PERMISSION_DENIED_MESSAGE = 'この操作を行う権限がありません。';

export function hasPermission(perms: readonly string[] | undefined, required: OpsPermission): boolean {
  return perms?.includes(required) ?? false;
}

export function hasAnyPermission(
  perms: readonly string[] | undefined,
  required: readonly OpsPermission[],
): boolean {
  if (!perms) return false;
  return required.some((p) => perms.includes(p));
}
